<section class="flex-container" *ngIf="showAll && !donutsCultivosInput">
    <div *ngFor="let cultivo of cultivosSinDesignaciones">
        <div *ngIf="cultivo !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{cultivo.label}}</label>
            <label [ngClass]="{'remove-label': !cultivo.subLabel}">{{cultivo.subLabel ? cultivo.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="cultivo.labelList" [dataList]="cultivo.dataList" [chartName]="'x'" [colors]="cultivo.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(cultivo.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(cultivo)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let cultivo of aforoActualAnterior">
        <div *ngIf="cultivo !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{cultivo.label}}</label>
            <label [ngClass]="{'remove-label': !cultivo.subLabel}">{{cultivo.subLabel ? cultivo.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="cultivo.labelList" [dataList]="cultivo.dataList" [chartName]="'x'" [colors]="cultivo.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(cultivo.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(cultivo)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
</section>
<section class="flex-container" *ngIf="!showAll">
    <div *ngFor="let donut of donutsPorPrioridad">
        <div *ngIf="donut !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{donut.label}}</label>
            <label>{{donut.subLabel}}</label>
            <lib-dougnhut-chart [labelList]="donut.labelList" [dataList]="donut.dataList" [chartName]="'x'" [colors]="donut.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(donut.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(donut)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
</section>
<section class="flex-container" *ngIf="showAll && donutsCultivosInput">
    <div *ngFor="let donut of allDonuts">
        <div *ngIf="donut !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{donut.label}}</label>
            <label>{{donut.subLabel}}</label>
            <lib-dougnhut-chart [labelList]="donut.labelList" [dataList]="donut.dataList" [chartName]="'x'" [colors]="donut.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(donut.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(donut)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
</section>
<div class="modal" *ngIf="gridModal">
    <div class="modal-content">
        <header>
            <h4>{{tituloGrid}}</h4>
            <i class="fas fa-times" (click)="gridModal = !gridModal"></i>
          </header>
        <app-grid-avisos-cultivos [titulo]="tituloGrid" (refresh)="refresh($event)"></app-grid-avisos-cultivos>
    </div>
</div>